
var DectectRTC = {
  TBS_MIN_VERSION: 43600,
  h264Support:false,
  checkTBSVersion: function() {
      var list = navigator.userAgent.split(" ");
      var isTBS = false;
      var TBSVersion = 0;
      for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (item.indexOf("TBS") !== -1 || item.indexOf("tbs") !== -1) {
              isTBS = true;
              var versionStr = item.split("/")[1];
              var version = parseInt(versionStr) || 0;
                  TBSVersion = version
          }
      }
      return {
          isTBS : isTBS,
          TBSversion : TBSVersion,
          isTBSValid: TBSVersion >= this.TBS_MIN_VERSION
      };
  },
  checkH264Support : function( callback ){
      if(window.RTCPeerConnection){
          var peer = new RTCPeerConnection(null);
          peer.createOffer({
          offerToReceiveAudio: 1,
          offerToReceiveVideo: 1
          }).then(function(data){
              if( data.sdp.toLowerCase().indexOf("h264") === -1 ){
                  callback( false )
              }else{
                  callback( true )
              }
              peer.close();
          },function(data){
              callback( false )
          });
      } else{
          callback( false )
      }
  },

  support: function( opts, callback ){
      if( typeof opts === 'function'){
          this.doCheck({ screenshare: false }, opts)
      }else{
          this.doCheck( opts , callback)
      }
  },
  doCheck: function(opts, callback ){
      var isWebRTCSupported = false;
      ['RTCPeerConnection', 'webkitRTCPeerConnection', 'RTCIceGatherer'].forEach(function(item) {
          if (isWebRTCSupported) {
              return;
          }
          if (item in window) {
              isWebRTCSupported = true;
          }
      });
      var TBSInfo = this.checkTBSVersion();
      if( !TBSInfo.isTBS ){
          if( this.isFF() ){
              isWebRTCSupported = false
          }else if( this.isSafari() && navigator.platform.indexOf("Mac") ===-1 ){
              var iOSVersion = this.iOSVersion();
              if(iOSVersion && ( 
                  (iOSVersion[0]>=11 && iOSVersion[1]>=1) 
                  || iOSVersion[0]>=12) 
                  ){
                  //console.log("doCheck, support webrtc, iOSVersion: " + iOSVersion);
              }else{
                  //console.log("doCheck, no support webrtc, iOSVersion: " + iOSVersion);
                  isWebRTCSupported = false
              }
          }
          
          if(this.isWechatdevtools()){
            isWebRTCSupported = true
          }
      }
      
      var ret =  {
          support: isWebRTCSupported,
          isTBS : TBSInfo.isTBS,
          isTBSValid: TBSInfo.isTBSValid,
          TBSversion : TBSInfo.TBSversion,
          isSafari : this.isSafari(),
          iOSVersion : this.iOSVersion(),
          screenshare:false,
          isFF : this.isFF(),
          userAgent: Browser.client
      };
      if(!isWebRTCSupported){
          ret.h264Support = false;
          callback(ret);
          return;
      }
      this.checkH264Support(function(support){
          ret.h264Support = support
          if( !support ){
              ret.support = false;
          }
          if( !opts.screenshare && callback){
              delete ret.screenshare;
              callback( ret )
              return;
          }
          // chrome 70 版本以后无需安装插件
          if( parseFloat( Browser.client.version ) >= 70 && Browser.client.type === 'chrome'){
              console.debug('[DetectRTC]: chrome 70 版本以后无需安装插件')
              ret.screenshare = true;
              callback( ret )
              return;
          }
          var extensionId = opts.extensionId || null;
          ScreenChromeExtensionUtil.getChromeExtensionStatus(extensionId, function( extensionResult ) {
              if (extensionResult === 'installed-enabled') {
                  ScreenChromeExtensionUtil.isChromeExtensionAvailable(function(isAvailable) {
                      if (!isAvailable) {
                          // alert('检测没有通过，请先安装chrome屏幕分享插件');
                      } else {
                          // alert('检测通过，可以进入Demo');
                          ret.screenshare = true;
                      }
                      if( callback ){
                          callback( ret )
                      }
                  });
              } else {
                  if( callback ){
                      callback( ret )
                  }
              }
          });
      });
      return ret;
  },
  isTBS: function(){
      var result = this.checkTBSVersion();
      return result.isTBS;
  },
  isSafari: function(){
      return navigator.userAgent.toLowerCase().indexOf('safari/') > -1 &&  navigator.userAgent.toLowerCase().indexOf('chrome/') === -1;
  },
  iOSVersion: function(){
      var matches = (navigator.userAgent).match(/OS (\d+)_(\d+)_?(\d+)?/);
      return (matches && [
          parseInt(matches[1]),
          parseInt(matches[2]),
          parseInt(matches[3] || 0)
      ] || false)
  },
  isFF: function(){
      return navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
  },
  isChrome: function(){
      return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  },
  isWechatdevtools: function(){
    return navigator.userAgent.toLowerCase().indexOf("wechatdevtools") !== -1;
  },
  detectMediaDevice: function( callback ){
      var hasAudio = false;
      var hasVideo = false;
      navigator.mediaDevices.enumerateDevices()
      .then(function(devices) {
          devices.forEach(function(device) {
              if (device && device.kind === "videoinput" ) {
                  hasVideo = true;
              }else if (device && device.kind === "audioinput" ) {
                  hasAudio = true;
              }
          });
          if( callback){
              callback( {
                  hasAudio: hasAudio,
                  hasVideo: hasVideo
              } );
          }
      })
      .catch(function(err) {
          if( callback ){
              callback( {
                  hasAudio: hasAudio,
                  hasVideo: hasVideo
              } );
          }
      });

  }
}

module.exports = DectectRTC;

